"use strict";

angular.module("core")
.service("ValidateBrowserCookieSupportService", function($http, $q, appConfig) {
    this.validate = function() {
        var deferred = $q.defer();
        $http.get(appConfig.API_SERVER + "/validate-browser-cookie-support", {}).then(
            function() {
                $http.post(appConfig.API_SERVER + "/validate-browser-cookie-support", {}).then(
                    deferred.resolve,
                    deferred.reject
                )
            }
        );
        return deferred.promise;
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/validate-browser-cookie-support/validate-browser-cookie-support.service.js
// module id = 437
// module chunks = 0